import './index.scss'
// let numlist = []
// let num = $('.section1 .left .info div')//.eq(0).height()
// $.each(num,function(index,item){
//   numlist.push(item.offsetHeight)
// })
// let allnum =  Math.max.apply(null, numlist);
// $('.section1 .left .info .source').css({'height': allnum+'px'})